export default{

    hover: {
        color: '#f6e4b7',
        transition: 'all .5s ease-in-out',
    }
};